import React, { useMemo } from 'react';
import AnalysisCard from '../AnalysisCard';
import useLanguage from '@op/hooks/useLanguage';
import { useSummaryKeywordDrillStats } from '../../hook';
import { reviewsFormat } from '@op/utils/value';
import MobileRatingCard from '../MobileRatingCard';
import { formatDateFunc } from '@op/utils/time';
import BubbleCommon, {
  keywordDrillUrlMobileFilteredReviewsTips,
} from '@op/components/BubbleCommon';

const MobileMetricsCard = (props: any) => {
  const { filter, tab, gameInfo } = props;
  const { formatMessage } = useLanguage();

  const params = useMemo(
    () => ({
      ...filter,
      channel: [tab],
      tab_type: 'mobile',
      need_link: true,
    }),
    [filter, tab],
  );

  const { data, loading, error } = useSummaryKeywordDrillStats({
    filter: params,
    gameInfo,
  });

  return (
    <>
      {/* Filtered Reviews */}
      <AnalysisCard
        value={data?.filtered_reviews || 0}
        title={
          <BubbleCommon
            showIcon={false}
            tipsMap={keywordDrillUrlMobileFilteredReviewsTips}
          >
            {formatMessage({ id: 'Filtered Reviews' })}
          </BubbleCommon>
        }
        percentValue={data?.filtered_reviews_ratio || 0}
        footer={formatMessage(
          { id: 'out of {total} Reviews' },
          {
            total: (
              <span className="footer-value-text">
                {reviewsFormat(data?.total_reviews || 0)}
              </span>
            ),
          },
        )}
        loading={loading}
        loadingHeight={56}
        // empty={false}
        bubbleProps={{
          showContent: !!data?.filtered_reviews,
          oldTime: [data?.link_of_start_time, data?.link_of_end_time],
          newTime: [data?.start_time, data?.end_time],
          oldValue: data?.filtered_reviews_old,
          newValue: data?.filtered_reviews,
          formateDate: formatDateFunc(filter?.date_type || 'daily'),
          formateValue: reviewsFormat,
        }}
      />

      {/* Filtered Rating */}
      <MobileRatingCard
        data={data}
        loading={loading}
        loadingHeight={190}
        filter={filter}
        error={error}
      />
    </>
  );
};

export default MobileMetricsCard;
